import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../../Context';
import { LoginNavbar } from '../LoginNavbar';
import MobileNavbar from '../MobileNavbar/MobileNavbar';
import './ResponsiveNavbar.scss';

const ResponsiveNavbar = () => {
  const { isAuth } = useContext(AppContext);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Detectar cambios en el tamaño de la ventana para determinar si es móvil
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!isAuth) return null;

  return (
    <>
      {/* Barra lateral para escritorio */}
      {!isMobile && <LoginNavbar />}
      
      {/* Barra de navegación inferior para móviles */}
      {isMobile && <MobileNavbar />}
    </>
  );
};

export default ResponsiveNavbar;